module.exports = __webpack_public_path__ + "media/stylesheets/opensans300-d0b483ce9717b92b4bf815d5d4db597a.woff";